import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from '../../messages';

const getDaysFromDate = (date) => {
  return Math.ceil((new Date(date) - new Date()) / (1000 * 60 * 60 * 24));
};

export const getDeliveryTimeStringFromRate = ({ maxDeliveryDate, minDeliveryDate }) => {
  if (maxDeliveryDate && minDeliveryDate) {
    return (
      <FormattedMessage
        {...messages.deliveryEstimateRange}
        values={{
          minNumberOfDays: getDaysFromDate(minDeliveryDate),
          maxNumberOfDays: getDaysFromDate(maxDeliveryDate),
        }}
      />
    );
  }
  if (maxDeliveryDate) {
    return <FormattedMessage {...messages.deliveryEstimate} values={{ numberOfDays: getDaysFromDate(maxDeliveryDate) }} />;
  }
  if (minDeliveryDate) {
    return <FormattedMessage {...messages.deliveryEstimate} values={{ numberOfDays: getDaysFromDate(minDeliveryDate) }} />;
  }
  return <React.Fragment />;
};
